import React from 'react';
import './LogoXSymbol.scss';

function LogoXSymbol() {
    return <div className="LogoXSymbol" />;
}

export default LogoXSymbol;
